<template>
  <div class="interest-free">
    <header></header>
    <section>
      <img src="./images/btn_tixian@2x.png" class="button-img" @click="downloadApp"/>
      <div class="content">
        <p>最长用12个月，综合年化利率15.4%起（单利计算）</p>
        <p>1000元借1天，低至0.43元</p>
      </div>
      <div class="list-item">
        <div class="item">
          <img
            src="./images/icon_01.png"
            srcset="
                            ./images/icon_01@2x.png 2x,
                            ./images/icon_01@3x.png 3x
                        "
          />
          <div class="text-1">快速审批</div>
          <div class="text-2">最快5分钟放款</div>
        </div>
        <div class="item">
          <img
            src="./images/icon_02.png"
            srcset="
                            ./images/icon_02@2x.png 2x,
                            ./images/icon_02@3x.png 3x
                        "
          />
          <div class="text-1">分期偿还</div>
          <div class="text-2">可分12期偿还</div>
        </div>
        <div class="item">
          <img
            src="./images/icon_03.png"
            srcset="
                            ./images/icon_03@2x.png 2x,
                            ./images/icon_03@3x.png 3x
                        "
          />
          <div class="text-1">放心使用</div>
          <div class="text-2">正规持牌机构</div>
        </div>
      </div>
    </section>
    <div class="foot">
      <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间15.4%-24%，单利计算)</p>
      <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
      <div class="mt24">
        <p>重庆市崇天小额贷款有限公司</p>
        <p>公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
        <p>渝公网安备 50010802002638号I渝ICP备18009772号-1</p>
      </div>
    </div>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
 
export default {
  name: 'iRR24-result',
  // customReadyNotify: true,
  data () {
    return {
    }
  },
  methods: {
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('iframe')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.src = schema
        body.appendChild(node)
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    }
     
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.interest-free {
    min-height: 100%;
    background: #FFE7DB;
    padding:39px 0 0 0;
    header{
        margin-left:40px;
        background:url('./images/img_zi2@2x.png') no-repeat;
        width:319px;
        height:60px;
        background-size:cover;
      }
      section{
          background:url('./images/bg@2x.png') no-repeat;
          width:750px;
          height:1210px;
          background-size:cover;
          padding-top:645px;
          .button-img{
              display: block;
              width:440px;
              height:122px;
              margin:auto;
              animation: hand 2s linear infinite;
          }
          @keyframes hand {
            0% {
                transform: scale(1);
            }
            50% {
                transform: scale(0.8);
            }
            100% {
                transform: scale(1);
            }
            }
          .content{
              margin-top:30px;
              text-align: center;
              >p{
                height: 30px;
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 30px;
              }
          }
          .list-item {
            display: flex;
            justify-content: space-between;
            padding: 79px 85px 0;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > img {
                    width: 90px;
                    height: 90px;
                }
                .text-1 {
                    margin-top: 18px;
                    font-size: 28px;
                    text-align: center;
                    color: #333333;
                    line-height: 40px;
                }
                .text-2 {
                    font-size: 24px;
                    text-align: center;
                    color: #999999;
                    line-height: 40px;
                }
                }
            }   
        }
    .foot{
        background: #FFB190;
        padding:24px 0 24px 30px;
        .mt24{
            margin-top:24px;
        }
        p{
            width: 687px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
  }
}
</style>
